const html = document.querySelector("html");
const body = document.querySelector("body");
const lightboxBackground = document.querySelector(
  ".produse-participante-section .voting_system .row"
);
const buttonsWrapper = document.querySelector(".buttons_wrapper");
const cardImagesWrapper = Array.from(
  document.querySelectorAll(".card-categorie.inactive .image_wrapper")
);
const cardImages = Array.from(document.querySelectorAll(".image_wrapper img"));

const imagesDataLightbox = cardImages.map((image) =>
  image.getAttribute("data-lightbox")
);

const imagesSrc = cardImages.map((image) => image.src);

let currentIndex = 0;
let buttonsAdded = false;
let clickListenerAdded = false;
let touchStartX = 0;
let touchEndX = 0;
const swipeThreshold = 50;

const leftButton = document.createElement("button");
leftButton.innerHTML =
  '<svg class="prev" width="22" height="22" viewBox="0 0 320 512"><path fill="#333" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>';
leftButton.classList.add("prev");
leftButton.addEventListener("click", () => navigateCarousel("prev"));

const rightButton = document.createElement("button");
rightButton.innerHTML =
  '<svg class="next" width="22" height="22" viewBox="0 0 320 512"><path fill="#333" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>';
rightButton.classList.add("next");
rightButton.addEventListener("click", () => navigateCarousel("next"));

buttonsWrapper.appendChild(leftButton);
buttonsWrapper.appendChild(rightButton);

function setupLightbox(card, index) {
  const cardWrapper = card.parentNode;
  const cardParent = cardWrapper.parentNode;
  const selectedImage = card.querySelector("img");
  const loadingImage = cardParent.querySelector(".view-image-loading");
  const cardArrows = cardParent.querySelectorAll(".arrow span");

  const selectedImageSrc = imagesDataLightbox[currentIndex];
  const selectedImageDataLightbox = imagesSrc[currentIndex];

  const prevSelectedCard = document.querySelector(".lightbox.active");
  if (prevSelectedCard) {
    const prevSelectedCardWrapper =
      prevSelectedCard.querySelector(".lightbox_wrapper");
    const prevSelectedImage = prevSelectedCardWrapper.querySelector("img");

    const selectedImageSrc = prevSelectedImage.src;
    const selectedImageDataLightbox = prevSelectedImage.dataset.lightbox;

    prevSelectedCard.classList.remove("lightbox", "active");
    prevSelectedCardWrapper.classList.remove(
      "lightbox_wrapper",
      "view-image-lead__in"
    );
    prevSelectedImage.dataset.lightbox = selectedImageSrc;
    prevSelectedImage.src = selectedImageDataLightbox;
    const prevCloseButton =
      prevSelectedCardWrapper.querySelector(".close_button");
    prevSelectedCardWrapper.removeChild(prevCloseButton);
    prevSelectedCardWrapper.style.pointerEvents = "auto";
  }

  loadingImage.classList.add("active");
  cardParent.classList.remove("inactive");
  cardParent.classList.add("lightbox", "active");
  cardWrapper.classList.add("lightbox_wrapper", "view-image-lead__in");

  cardWrapper.style.opacity = 0;

  if (cardWrapper.classList.contains("view-image-lead__in")) {
    cardWrapper.classList.add("view-image-lead__out");
    cardWrapper.classList.remove("view-image-lead__in");
  }

  setTimeout(() => {
    selectedImage.onload = function () {
      setTimeout(() => {
        loadingImage.classList.remove("active");
        cardWrapper.classList.remove("view-image-lead__out");
        cardWrapper.classList.add("view-image-lead__in");
      }, 200);
    };
    selectedImage.dataset.lightbox = selectedImageDataLightbox;
    selectedImage.src = selectedImageSrc;
    cardWrapper.style.opacity = 1;

    cardArrows.forEach((arrow, index) => {
      let delay;

      if (index === 1) {
        delay = 0.2;
      } else if (index === 2) {
        delay = 0.4;
      } else {
        delay = 0;
      }

      arrow.style.animation = `animate 2s infinite ${delay}s`;
    });

    if (window.innerWidth > 992) {
      cardWrapper.style.pointerEvents = "none";
    } else {
      cardWrapper.style.pointerEvents = "all";
    }
    if (window.innerWidth > 991) {
      buttonsWrapper.style.display = "grid";
    } else {
      buttonsWrapper.style.display = "none";
    }
  }, 600);

  // ------- CLOSE THE LIGHTBOX -------

  if (clickListenerAdded) {
    cardParent.addEventListener("click", (event) => {
      if (event.target === event.currentTarget) {
        lightboxBackground.classList.remove("active");
        cardParent.classList.remove("lightbox", "active");
        cardWrapper.classList.remove("lightbox_wrapper", "view-image-lead__in");
        cardWrapper.classList.add("view-image-lead__out");
        selectedImage.dataset.lightbox = selectedImageSrc;
        selectedImage.src = selectedImageDataLightbox;
        if (closeButton && closeButton.parentElement) {
          cardWrapper.removeChild(closeButton);
        }
        cardWrapper.style.pointerEvents = "auto";
        buttonsWrapper.style.display = "none";
        clickListenerAdded = false;
        body.style.overflow = "";
        html.style.overflow = "";
      }
    });
  }

  const closeButton = document.createElement("button");
  closeButton.classList.add("close_button");
  closeButton.style.pointerEvents = "all";
  closeButton.innerHTML =
    '<svg width="22" height="22" viewBox="0 0 384 512"><path fill="#333" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';
  cardWrapper.appendChild(closeButton);
  closeButton.addEventListener("click", () => {
    lightboxBackground.classList.remove("active");
    cardParent.classList.remove("lightbox", "active");
    cardWrapper.classList.remove("lightbox_wrapper", "view-image-lead__in");
    cardWrapper.classList.add("view-image-lead__out");
    selectedImage.dataset.lightbox = selectedImageSrc;
    selectedImage.src = selectedImageDataLightbox;
    cardWrapper.removeChild(closeButton);
    cardWrapper.style.pointerEvents = "auto";
    buttonsWrapper.style.display = "none";
    clickListenerAdded = false;
    body.style.overflow = "";
    html.style.overflow = "";
  });
}

cardImagesWrapper.forEach(function (card, index) {
  card.addEventListener("click", function () {
    if (!clickListenerAdded) {
      clickListenerAdded = true;
      card.classList.remove("inactive");
      lightboxBackground.classList.add("active");
      body.style.overflow = "hidden";
      html.style.overflow = "hidden";
      currentIndex = index;
      setupLightbox(card, currentIndex);
    }
  });
});

lightboxBackground.addEventListener("touchstart", handleTouchStart, false);
lightboxBackground.addEventListener("touchend", handleTouchEnd, false);

function handleTouchStart(event) {
  touchStartX = event.touches[0].clientX;
}

function handleTouchEnd(event) {
  touchEndX = event.changedTouches[0].clientX;
  handleSwipe();
}

function handleSwipe() {
  const deltaX = touchEndX - touchStartX;

  if (Math.abs(deltaX) > swipeThreshold) {
    if (deltaX > 0) {
      // Swipe right
      navigateCarousel("prev");
    } else {
      // Swipe left
      navigateCarousel("next");
    }
  }
}

function navigateCarousel(direction) {
  const totalImages = cardImagesWrapper.length;

  if (direction === "prev") {
    currentIndex = (currentIndex - 1 + totalImages) % totalImages;
  } else if (direction === "next") {
    currentIndex = (currentIndex + 1) % totalImages;
  }

  const card = cardImagesWrapper[currentIndex];
  setupLightbox(card, currentIndex);
}
